import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_COMPLIANCE_MANAGEMENT_ACTIVE_GROUPS:
      return state
        .set('groups', fromJS(action.payload))
    default:
      return state
  }
}
